export class BudgetRevisionRequestContractError extends Error {
  constructor(detail) {
    super(`Invalid budget revision request: ${detail}`);
    this.name = 'BudgetRevisionRequestContractError';
    this.code = 'INVALID_API_REQUEST';
  }
}
const fail = detail => {throw new BudgetRevisionRequestContractError(detail);};
const record = value => value !== null && typeof value === 'object' && !Array.isArray(value);
export function readBudgetRevisionIdentifier(value) {
  if (typeof value !== 'string' || !/^[a-f\d]{24}$/i.test(value)) fail('expected a scalar target or page ID.');
  return value;
}
export function readBudgetRevisionQuery(query) {
  if (!record(query)) fail('expected query fields.');
  for (const field of ['before', 'allocationId']) if (query[field] !== undefined && query[field] !== '') readBudgetRevisionIdentifier(query[field]);
  if (query.status !== undefined && query.status !== '' && !['proposed', 'approved', 'declined', 'withdrawn'].includes(query.status)) fail('invalid status.');
  return query;
}
export function readBudgetRevisionActionRequest(action, payload) {
  if (!['propose', 'approve', 'decline', 'withdraw'].includes(action)) fail('unknown action.');
  if (!record(payload)) fail('expected an object.');
  const fields = action === 'propose' ? ['requestId', 'allocationId', 'allocationVersion', 'amount', 'note', 'confirmDecision'] : ['requestId', 'id', 'revision', 'allocationVersion', 'note', 'confirmDecision'];
  if (Object.keys(payload).some(key => !fields.includes(key))) fail('only known revision decision fields are allowed.');
  if (payload.requestId !== undefined && (typeof payload.requestId !== 'string' || !/^[a-zA-Z0-9_-]{8,128}$/.test(payload.requestId))) fail('invalid requestId.');
  if (typeof payload.note !== 'string' || !payload.note.trim() || payload.note.trim().length > 2000) fail('a reason or decision reference is required.');
  if (payload.confirmDecision !== true) fail('confirm the decision.');
  readBudgetRevisionIdentifier(action === 'propose' ? payload.allocationId : payload.id);
  if (action === 'propose') {
    if (!['number', 'string'].includes(typeof payload.amount) || !/^\d+(?:\.\d{1,2})?$/.test(String(payload.amount).trim()) || !Number.isSafeInteger(Math.round(Number(payload.amount) * 100)) || Math.round(Number(payload.amount) * 100) > 100000000000) fail('amount must be non-negative decimal money within the supported range.');
  } else if (!Number.isSafeInteger(payload.revision) || payload.revision < 0) fail('invalid revision version.');
  if ((action === 'propose' || action === 'approve' || payload.allocationVersion !== undefined)
    && (typeof payload.allocationVersion !== 'string' || !payload.allocationVersion.trim())) fail('a current allocation version is required.');
  return payload;
}
